export default "__VITE_PUBLIC_ASSET__5922770f__"